import React from 'react'
import { useIntl } from 'react-intl';
import { Dropdown } from 'rsuite';
import { useMeetingStore } from '../../stores/MeetingsStore';
import { useSettingsStore } from '../../stores/SettingsStore';

interface ButtonDropdownMeetingProps {
    setTypeMeeting: (typeMeeting: 'schedule' | 'visit' | 'report' | 'schedule-visit') => void;
    setShowModalAddScheduleMeeting: (show: boolean) => void;
    setShowModalAddReportMeeting: (show: boolean) => void;
    setShowModalAddVisitMeeting: (show: boolean) => void;
    setShowModalAddScheduleVisitMeeting: (show: boolean) => void;
}

const ButtonDropdownMeeting = ({
    setTypeMeeting,
    setShowModalAddScheduleMeeting,
    setShowModalAddReportMeeting,
    setShowModalAddVisitMeeting,
    setShowModalAddScheduleVisitMeeting
}: ButtonDropdownMeetingProps) => {
    const intl = useIntl();
    const { selectMultiMeeting } = useMeetingStore();
    const { settings } = useSettingsStore();

    const renderButton = (props: any, ref: any) => (
        <button {...props} ref={ref} className="btn btn-primary mt-3">
            <i className="fas fa-plus"></i>{' '}
            {intl.formatMessage({ id: 'FORM.ACTION.ADD' })} {selectMultiMeeting.name}
        </button>
    );

    const getDropdownItems = (): React.ReactNode[] => {
        const actions: React.ReactNode[] = [];
        const mode = settings.feature_meeting_mode || '';

        if (mode.includes('1')) {
            actions.push(
                <Dropdown.Item key="report" onClick={() => {
                    setTypeMeeting('report');
                    setShowModalAddReportMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'MEETING.ACTION.FINISHED' })}
                </Dropdown.Item>
            );
        }

        if (mode.includes('2')) {
            actions.push(
                <Dropdown.Item key="schedule" onClick={() => {
                    setTypeMeeting('schedule');
                    setShowModalAddScheduleMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'MEETING.ACTION.SCHEDULED' })}
                </Dropdown.Item>
            );
        }

        if (mode.includes('3')) {
            actions.push(
                <Dropdown.Item key="visit" onClick={() => {
                    setTypeMeeting('visit');
                    setShowModalAddVisitMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'MEETING.ACTION.VISIT' })}
                </Dropdown.Item>
            );
        }

        if (mode.includes('4')) {
            actions.push(
                <Dropdown.Item key="schedule-visit" onClick={() => {
                    setTypeMeeting('schedule-visit');
                    setShowModalAddScheduleVisitMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'FORM.LABEL.VISIT_SCHEDULE' })}
                </Dropdown.Item>
            );
        }

        // Fallback: jika tidak ada yang cocok, tampilkan semua item
        if (actions.length === 0) {
            actions.push(
                <Dropdown.Item key="schedule" onClick={() => {
                    setTypeMeeting('schedule');
                    setShowModalAddScheduleMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'MEETING.ACTION.SCHEDULED' })}
                </Dropdown.Item>,
                <Dropdown.Item key="report" onClick={() => {
                    setTypeMeeting('report');
                    setShowModalAddReportMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'MEETING.ACTION.FINISHED' })}
                </Dropdown.Item>,
                <Dropdown.Item key="visit" onClick={() => {
                    setTypeMeeting('visit');
                    setShowModalAddVisitMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'MEETING.ACTION.VISIT' })}
                </Dropdown.Item>,
                <Dropdown.Item key="schedule-visit" onClick={() => {
                    setTypeMeeting('schedule-visit');
                    setShowModalAddScheduleVisitMeeting(true);
                }}>
                    {intl.formatMessage({ id: 'FORM.LABEL.VISIT_SCHEDULE' })}
                </Dropdown.Item>
            );
        }

        return actions;
    };

    return (
        <Dropdown renderToggle={renderButton} noCaret placement="bottomEnd">
            {getDropdownItems()}
        </Dropdown>
    );
};

export default ButtonDropdownMeeting;
